var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1389 11.3609L8.6411 3.112C8.52741 3.04252 8.39726 3.00458 8.26404 3.00208C8.13083 2.99959 7.99935 3.03263 7.88314 3.0978C7.76692 3.16298 7.67017 3.25793 7.60283 3.37291C7.5355 3.48788 7.5 3.61871 7.5 3.75195V20.2498C7.5 20.3831 7.5355 20.5139 7.60283 20.6289C7.67017 20.7438 7.76692 20.8388 7.88314 20.904C7.99935 20.9691 8.13083 21.0022 8.26404 20.9997C8.39726 20.9972 8.52741 20.9593 8.6411 20.8898L22.1389 12.6408C22.2485 12.5738 22.3391 12.4798 22.402 12.3677C22.4648 12.2557 22.4978 12.1294 22.4978 12.0009C22.4978 11.8724 22.4648 11.7461 22.402 11.634C22.3391 11.522 22.2485 11.4279 22.1389 11.3609Z",
    stroke: "#339EEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.cf51d68bb77b59caf083092d1756cc08.svg";
export { ForwardRef as ReactComponent };